export default [
    {
        path: '/ui/auth',
        name: 'auth',
        redirect: { name: 'login' },
        component: () => import('layouts/UnloggedLayout.vue'),
        children: [
            {
                path: 'login',
                name: 'login',
                component: () => import('pages/auth/login/index.vue'),
            },
            {
                path: 'password_reset',
                name: 'password-reset',
                component: () => import('pages/auth/password_reset/index.vue'),
            },
            {
                path: 'set_password',
                name: 'set-password',
                component: () => import('pages/auth/set_password/index.vue'),
            },
        ],
    },
];
